import AppStoreContext from 'contexts/AppStoreContext';
import React from 'react';
import FileManagerModalFC from './FileManagerModalFC';

class FileManagerModal extends React.Component {
  static modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      top: 'calc(50vh - 306px)',
      left: 'calc(50vw - 270px)',
      bottom: 'initial',
      right: 'initial',
      width: '540px',
      height: '660px',
      padding: '0px',
    },
  };

  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  render(): React.ReactNode {
    return <FileManagerModalFC />;
  }
}

export default FileManagerModal;
